var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"items-center"},[_c('apexCharts',{attrs:{"type":"area","series":_vm.series,"options":_vm.options,"height":"300"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }